// eslint-disable-next-line no-restricted-imports
import useWindowPopUp from 'Shared/Hooks/useWindowPopUp';

function usePopupChat() {
  const chatPopupUrl =
    typeof window !== 'undefined' ? `${window.location.href}chat/` : '';
  const [{ isOpen, closeWindow }, openLiveTabsPopup] = useWindowPopUp(
    chatPopupUrl,
    {
      width: 414,
      height: 736,
    },
  );

  return { isOpen, open: openLiveTabsPopup, close: closeWindow };
}

export default usePopupChat;
